import React, { useState, useEffect, useRef } from 'react';
import { supabase } from '../supabaseClient';
import '../styles/Contact.css';

/* ════════════════════════════════════════════════════════════
   CONTACT + FOOTER — تواصل
   Contact form with Supabase storage + social links + footer
   ════════════════════════════════════════════════════════════ */

/* ── Social links — update with real URLs ────────────── */
const SOCIAL_LINKS = [
  {
    id: 'facebook1',
    label: 'فيسبوك — Wajdi A Samad',
    labelEn: 'Facebook Personal',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    ),
    url: 'https://www.facebook.com/wajdi.a.samad',
  },
  {
    id: 'facebook2',
    label: 'فيسبوك — Wajdi Abdulsamad',
    labelEn: 'Facebook Page',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    ),
    url: 'https://www.facebook.com/wajdi.abdulsamad',
  },
  {
    id: 'instagram',
    label: 'إنستغرام',
    labelEn: 'Instagram',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
      </svg>
    ),
    url: 'https://www.instagram.com/samadwajdi',
  },
  {
    id: 'whatsapp',
    label: 'واتساب',
    labelEn: 'WhatsApp',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
      </svg>
    ),
    url: 'https://wa.me/96176490105',
  },
  {
    id: 'phone',
    label: 'هاتف: 490105 76 961+',
    labelEn: 'Phone',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
      </svg>
    ),
    url: 'tel:+96176490105',
  },
  {
    id: 'email',
    label: 'البريد الإلكتروني',
    labelEn: 'Email',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
        <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
      </svg>
    ),
    url: 'mailto:wajdijad@yahoo.com',
  },
];

/* ── Navbar links for footer ─────────────────────────── */
const FOOTER_NAV = [
  { id: 'home', label: 'الرئيسية' },
  { id: 'about', label: 'السيرة' },
  { id: 'books', label: 'الإصدارات' },
  { id: 'munfaridat', label: 'قصائد متنوعة' },
  { id: 'videos', label: 'مرئيات' },
  { id: 'events', label: 'الفعاليات' },
];

export default function Contact() {
  /* ── State ──────────────────────────────────────────── */
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [status, setStatus] = useState(null); // 'sending' | 'success' | 'error'
  const [revealed, setRevealed] = useState(new Set());
  const sectionRef = useRef(null);
  const cardRefs = useRef({});

  /* ── Scroll reveal ─────────────────────────────────── */
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            const id = e.target.dataset.rid;
            if (id) setRevealed((prev) => new Set(prev).add(id));
          }
        });
      },
      { threshold: 0.15 }
    );
    Object.values(cardRefs.current).forEach((el) => el && obs.observe(el));
    return () => obs.disconnect();
  }, []);

  /* ── Form handlers ─────────────────────────────────── */
  const handleChange = (field, value) => {
    // Enforce max lengths on input
    const limits = { name: 200, email: 320, subject: 500, message: 5000 };
    if (value.length > (limits[field] || 5000)) return;
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  /* ── Sanitize: strip HTML tags ─────────────────────── */
  const sanitize = (str) => {
    const div = document.createElement('div');
    div.textContent = str.trim();
    return div.innerHTML;
  };

  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async () => {
    setErrorMsg('');

    // Validate required fields
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      setStatus('error');
      setErrorMsg('يرجى ملء جميع الحقول المطلوبة');
      setTimeout(() => setStatus(null), 3000);
      return;
    }

    // Email validation
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) {
      setStatus('error');
      setErrorMsg('يرجى إدخال بريد إلكتروني صحيح');
      setTimeout(() => setStatus(null), 3000);
      return;
    }

    // Length checks (matches database policy)
    if (form.name.trim().length > 200 || form.message.trim().length > 5000) {
      setStatus('error');
      setErrorMsg('النص طويل جداً');
      setTimeout(() => setStatus(null), 3000);
      return;
    }

    setStatus('sending');

    try {
      const { error } = await supabase.from('contact_messages').insert([
        {
          name: sanitize(form.name),
          email: form.email.trim().toLowerCase(),
          subject: form.subject.trim() ? sanitize(form.subject) : null,
          message: sanitize(form.message),
        },
      ]);

      if (error) {
        // Handle rate limiting from database
        if (error.message?.includes('Rate limit') || error.message?.includes('Too many')) {
          setErrorMsg('لقد أرسلت عدة رسائل مؤخراً. يرجى المحاولة لاحقاً');
        }
        throw error;
      }

      setStatus('success');
      setForm({ name: '', email: '', subject: '', message: '' });
      setTimeout(() => setStatus(null), 5000);
    } catch (err) {
      console.error('Contact form error:', err);
      setStatus('error');
      if (!errorMsg) setErrorMsg('حدث خطأ. يرجى المحاولة مرة أخرى');
      setTimeout(() => setStatus(null), 4000);
    }
  };

  /* ── Smooth scroll ─────────────────────────────────── */
  const scrollTo = (sectionId) => {
    const el = document.getElementById(sectionId);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  /* ── Render ─────────────────────────────────────────── */
  return (
    <>
      {/* ════════════════ CONTACT SECTION ════════════════ */}
      <section id="contact" className="ct-section" ref={sectionRef}>
        {/* Decorative background */}
        <div className="ct-bg-ornament">
          <span className="ct-bg-letter ct-bg-letter-1">✉</span>
          <span className="ct-bg-letter ct-bg-letter-2">ت</span>
        </div>

        {/* Section header */}
        <div className="section-title">
          <h2>تواصل</h2>
          <p>نسعد بتواصلكم واستفساراتكم</p>
          <div className="title-line" />
        </div>

        <div className="ct-container">
          {/* ── Left: Contact info + social ────────────── */}
          <div
            className={`ct-info-panel ${revealed.has('info') ? 'ct-revealed' : ''}`}
            ref={(el) => { cardRefs.current['info'] = el; }}
            data-rid="info"
          >
            <div className="ct-info-card">
              <div className="ct-info-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="32" height="32">
                  <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3>راسلنا</h3>
              <p className="ct-info-text">
                يسعدنا تلقّي رسائلكم وملاحظاتكم. سواء كانت دعوة لأمسية شعرية،
                استفسار عن الإصدارات، أو مجرد كلمة طيبة — نرحب بكم دائماً.
              </p>
            </div>

            {/* Social links */}
            <div className="ct-social-grid">
              <h4 className="ct-social-title">تابعونا</h4>
              <div className="ct-social-links">
                {SOCIAL_LINKS.map((link) => (
                  <a
                    key={link.id}
                    href={link.url}
                    className="ct-social-link"
                    target={link.url.startsWith('mailto') ? undefined : '_blank'}
                    rel={link.url.startsWith('mailto') ? undefined : 'noopener noreferrer'}
                    title={link.label}
                    aria-label={link.labelEn}
                  >
                    <span className="ct-social-icon">{link.icon}</span>
                    <span className="ct-social-label">{link.label}</span>
                  </a>
                ))}
              </div>
            </div>

            {/* Quote decoration */}
            <div className="ct-quote-deco">
              <span className="ct-quote-mark">«</span>
              <p>الشعر ما كان نبض القلب وصوت الروح</p>
            </div>
          </div>

          {/* ── Right: Contact form ────────────────────── */}
          <div
            className={`ct-form-panel ${revealed.has('form') ? 'ct-revealed' : ''}`}
            ref={(el) => { cardRefs.current['form'] = el; }}
            data-rid="form"
          >
            <div className="ct-form-card">
              <div className="ct-field">
                <label htmlFor="ct-name">الاسم الكريم *</label>
                <input
                  id="ct-name"
                  type="text"
                  value={form.name}
                  onChange={(e) => handleChange('name', e.target.value)}
                  placeholder="أدخل اسمك"
                  disabled={status === 'sending'}
                />
              </div>

              <div className="ct-field">
                <label htmlFor="ct-email">البريد الإلكتروني *</label>
                <input
                  id="ct-email"
                  type="email"
                  value={form.email}
                  onChange={(e) => handleChange('email', e.target.value)}
                  placeholder="example@email.com"
                  dir="ltr"
                  style={{ textAlign: 'right' }}
                  disabled={status === 'sending'}
                />
              </div>

              <div className="ct-field">
                <label htmlFor="ct-subject">الموضوع</label>
                <input
                  id="ct-subject"
                  type="text"
                  value={form.subject}
                  onChange={(e) => handleChange('subject', e.target.value)}
                  placeholder="موضوع الرسالة (اختياري)"
                  disabled={status === 'sending'}
                />
              </div>

              <div className="ct-field">
                <label htmlFor="ct-message">الرسالة *</label>
                <textarea
                  id="ct-message"
                  value={form.message}
                  onChange={(e) => handleChange('message', e.target.value)}
                  placeholder="اكتب رسالتك هنا..."
                  rows="5"
                  disabled={status === 'sending'}
                />
              </div>

              <button
                className={`ct-submit-btn ${status === 'sending' ? 'ct-sending' : ''}`}
                onClick={handleSubmit}
                disabled={status === 'sending'}
              >
                {status === 'sending' ? (
                  <>
                    <span className="ct-spinner" />
                    جار الإرسال...
                  </>
                ) : (
                  <>
                    <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                      <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
                    </svg>
                    إرسال الرسالة
                  </>
                )}
              </button>

              {/* Status messages */}
              {status === 'success' && (
                <div className="ct-status ct-status-success">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                  </svg>
                  شكراً لتواصلكم! تم إرسال رسالتكم بنجاح.
                </div>
              )}
              {status === 'error' && (
                <div className="ct-status ct-status-error">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                  </svg>
                  {errorMsg || 'يرجى ملء جميع الحقول المطلوبة بشكل صحيح.'}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* ════════════════ FOOTER ═════════════════════════ */}
      <footer className="ft-footer">
        {/* Gold accent line */}
        <div className="ft-top-line" />

        <div className="ft-container">
          {/* ── Brand column ──────────────────────────── */}
          <div className="ft-brand">
            <div className="ft-logo" onClick={() => scrollTo('home')} role="button" tabIndex={0}>
              <span className="ft-logo-letter">و</span>
              <div className="ft-logo-text">
                <span className="ft-logo-name">الشاعر وجدي عبد الصمد</span>
                <span className="ft-logo-sub">شاعر عربي معاصر</span>
              </div>
            </div>
            <p className="ft-brand-desc">
              من لبنان إلى أستراليا، شاعر يحمل الكلمة العربية إلى العالم
            </p>
          </div>

          {/* ── Nav column ────────────────────────────── */}
          <div className="ft-nav-col">
            <h4 className="ft-col-title">روابط سريعة</h4>
            <nav className="ft-nav">
              {FOOTER_NAV.map((item) => (
                <button
                  key={item.id}
                  className="ft-nav-link"
                  onClick={() => scrollTo(item.id)}
                >
                  {item.label}
                </button>
              ))}
            </nav>
          </div>

          {/* ── Social column ─────────────────────────── */}
          <div className="ft-social-col">
            <h4 className="ft-col-title">تواصل معنا</h4>
            <div className="ft-social-row">
              {SOCIAL_LINKS.map((link) => (
                <a
                  key={link.id}
                  href={link.url}
                  className="ft-social-btn"
                  target={link.url.startsWith('mailto') ? undefined : '_blank'}
                  rel={link.url.startsWith('mailto') ? undefined : 'noopener noreferrer'}
                  title={link.label}
                  aria-label={link.labelEn}
                >
                  {link.icon}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* ── Bottom bar ─────────────────────────────── */}
        <div className="ft-bottom">
          <p className="ft-copyright">
            © {new Date().getFullYear()} الشاعر وجدي عبد الصمد — جميع الحقوق محفوظة
          </p>
          <p className="ft-credit">
            صمم وطوّر بـ <span className="ft-heart">♥</span> بواسطة{' '}
            <a
              href="https://wa.me/9613119744?text=مرحباً، رأيت موقع الشاعر وجدي عبد الصمد وأريد أن أصمم موقع إلكتروني"
              target="_blank"
              rel="noopener noreferrer"
              className="ft-dev-link"
            >
              Yazan Zebian
            </a>
          </p>
        </div>
      </footer>
    </>
  );
}